import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import range from 'lodash/range';
import uniq from 'lodash/uniq';
import filter from 'lodash/filter';
import isNumber from 'lodash/isNumber';
import './stylesheets/Pagination.scss';

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = { offset: props.offset };
    this.offsetChanged = this.offsetChanged.bind(this);
    this.onComponentDidUpdate = () => {};
  }

  componentDidUpdate() {
    this.onComponentDidUpdate();
  }

  /* This wraps a block (function with no arguments) and saves the position
   * of the element relative to the window (pageYOffset), then restores that
   * relative position after running the block. It has to do it after the DOM
   * is rendered, so it sets onComponentDidUpdate, which is called on
   * componentDidUpdate above.
   */
  withSameScrollPosition(element, f) {
    const windowTopOffset = element.offsetTop - window.pageYOffset;
    f();
    this.onComponentDidUpdate = () => {
      window.scrollTo(0, element.offsetTop - windowTopOffset);
      this.onComponentDidUpdate = () => {};
    };
  }

  offsetChanged(newOffset) {
    return () => {
      /* eslint-disable */
      this.withSameScrollPosition(this.refs.paginationList, () => {
        const { onPageChange } = this.props;
        this.setState({ offset: newOffset });
        onPageChange(newOffset);
      });
      /* eslint-enable */
    };
  }

  renderArrow(offset, enabled, className) {
    const arrowClassNames = classNames({ disabled: !enabled }, className);

    return (
      /* eslint-disable */
      <li
        className={ arrowClassNames }
        onClick={ enabled ? this.offsetChanged(offset) : undefined }
      />
      /* eslint-enable */
    );
  }

  renderPageNumbers(currentPage, totalPages, perPage) {
    const MAX_SHOWN_PAGES = 11;
    let pages;
    if (currentPage <= 6 && totalPages >= MAX_SHOWN_PAGES) {
      pages = [...range(1, MAX_SHOWN_PAGES - 1), totalPages];
    } else if (currentPage <= MAX_SHOWN_PAGES - 5 && totalPages < MAX_SHOWN_PAGES) {
      pages = [...range(1, totalPages), totalPages];
    } else if (currentPage >= totalPages - 8) {
      pages = [1, ...range(totalPages - 8, totalPages), totalPages];
    } else {
      pages = filter(uniq([
        1,
        ...range(currentPage - 3, currentPage + 4),
        totalPages
      ]), p => p > 0 && p <= totalPages);
    }

    const pagesWithGaps = [];
    pages.forEach((p, i) => {
      const lastPage = pages[i - 1];
      if (lastPage && p > lastPage + 1) {
        pagesWithGaps.push(-1);
      }
      pagesWithGaps.push(p);
    });

    return pagesWithGaps.map((page, i) => {
      const active = currentPage === page;
      const className = active ? 'active' : undefined;

      const newOffset = (page - 1) * perPage;

      if (page < 0) {
        return <li className="gap" key={i}>...</li>; // eslint-disable-line
      }

      return (
        /* eslint-disable */
        <li
          key={ i }
          className={ className }
          onClick={ active ? undefined : this.offsetChanged(newOffset) }
        >
          { page }
        </li>
        /* eslint-enable */
      );
    });
  }

  render() {
    const { offset: stateOffset } = this.state;
    const { perPage, totalCount, offset: overrideOffset } = this.props;

    const classes = { widgetopia: true, pagination: true };
    const flattenedClassNames = classNames(classes);

    const offset = (isNumber(overrideOffset)) ? overrideOffset : stateOffset;
    const totalPages = Math.ceil(totalCount / perPage);
    const currentPage = Math.floor(offset / perPage) + 1;

    if (totalPages <= 1) {
      return (
        /* eslint-disable */
        <ul className={ flattenedClassNames } ref="paginationList"></ul>
        /* eslint-enable */
      );
    }

    return (
      /* eslint-disable */
      <ul className={ flattenedClassNames } ref="paginationList">
        { this.renderArrow(offset - perPage, offset >= perPage, 'previous-arrow') }
        { this.renderPageNumbers(currentPage, totalPages, perPage) }
        { this.renderArrow(offset + perPage, currentPage < totalPages, 'next-arrow') }
      </ul>
      /* eslint-enable */
    );
  }
}

Pagination.propTypes = {
  /** Number of children in any single page */
  perPage: PropTypes.number.isRequired,
  /** Total number of children in paginated collection */
  totalCount: PropTypes.number.isRequired,
  /** Callback triggered when page is changed */
  onPageChange: PropTypes.func,
  /** Indicates the element index in the collection to first be displayed */
  offset: PropTypes.number
};

Pagination.defaultProps = {
  onPageChange: () => {},
  offset: 0
};

export default Pagination;



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Pagination.jsx